import React, { useEffect, useState, useCallback } from 'react'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { ToastContainer } from "react-toastify";

function Business() {

    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;

    const [summary, setSummary] = useState({});
    const [tableLoading, setTableLoading] = useState(false);
    const [businessData, setBusinessData] = useState([]);
    const [pagination, setPagination] = useState({});

    const [user_id, setUserID] = useState("");
    const [clientName, setClientName] = useState("");
    const [businessAmount, setBusinessAmount] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const fetchBusinessData = useCallback(async (page = 1) => {
        setTableLoading(false);

        const searchData = {
            page,
            user_id: user_id || null,
            name: clientName || null,
            business: businessAmount || null,
            from_date: fromDate || null,
            to_date: toDate || null,
        };

        try {
            const response = await fetch(`${baseurl}/business/data`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(searchData),
            });

            const result = await response.json();

            if (result.status) {
                setBusinessData(result.data);
                setPagination(result.pagination);
                setSummary(result.summary);
            } else {
                setBusinessData([]);
            }

            setTableLoading(true);

        } catch (error) {
            console.error('Fetch error:', error);
            setTableLoading(true);
        }
    }, [authToken, baseurl, user_id, clientName, businessAmount, fromDate, toDate]);

    useEffect(() => {
        fetchBusinessData(1);
    }, [fetchBusinessData]);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.last_page) {
            fetchBusinessData(page);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleSearch = () => {
        fetchBusinessData(1);
    };

    return (
        <>
            <Header>
                <Auth />

                <div className="main-content app-content">
                    <div className="container-fluid">

                        {/* SUMMARY SECTION */}
                        <div className="row my-4">
                            {/* <div className="col-md-6">
                                <div className="card bg-primary text-white p-3">
                                    <h5>Total Records</h5>
                                    <h3>{summary?.total_records || 0}</h3>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card bg-success text-white p-3">
                                    <h5>Total Business Amount</h5>
                                    <h3>
                                        ${parseFloat(summary?.total_business_amount || 0).toFixed(2)}
                                    </h3>
                                </div>
                            </div> */}
                        </div>

                        {/* FILTER SECTION */}
                        <div className="card p-3 mb-4">
                            <div className="row">

                                <div className="col-md-3">
                                    <label>User ID</label>
                                    <input
                                        type="text"
                                        value={user_id}
                                        onChange={(e) => setUserID(e.target.value)}
                                        className="form-control"
                                        placeholder="Enter User ID"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        value={clientName}
                                        onChange={(e) => setClientName(e.target.value)}
                                        className="form-control"
                                        placeholder="Enter Name"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label>Business Amount</label>
                                    <input
                                        type="number"
                                        value={businessAmount}
                                        onChange={(e) => setBusinessAmount(e.target.value)}
                                        className="form-control"
                                        placeholder="Enter Business Amount"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <button
                                        onClick={handleSearch}
                                        className="btn btn-primary mt-4 w-100">
                                        Search
                                    </button>
                                </div>

                            </div>

                            <div className="row mt-3">
                                <div className="col-md-3">
                                    <label>From Date</label>
                                    <input
                                        type="date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        className="form-control"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label>To Date</label>
                                    <input
                                        type="date"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* TABLE SECTION */}
                        <div className="card p-3">
                            <h4 className="text-primary mb-3">Business Data</h4>

                            {tableLoading ? (
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Business Amount</th>
                                                <th>Date Time</th>
                                                <th>Created At</th>
                                                <th>Updated At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {businessData.length > 0 ? (
                                                businessData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td> <a href="/clientsDetails" onClick={() => { sessionStorage.setItem("clientId", item.user_id); }} className="text-primary" >
                                                            {item.name}
                                                        </a>
                                                        </td>
                                                        <td>${item.month_business}</td>
                                                        <td>{item.date_time}</td>
                                                        <td>{item.created_at}</td>
                                                        <td>{item.updated_at}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-center p-4">
                                    <div className="spinner-border"></div>
                                </div>
                            )}

                            {/* PAGINATION */}
                            {pagination?.total > 0 && (
                                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap">

                                    <div className="mb-2">
                                        Showing page <b>{pagination.current_page}</b> of <b>{pagination.last_page}</b> |
                                        Total Records: <b>{pagination.total}</b>
                                    </div>

                                    <div className="d-flex align-items-center flex-wrap gap-1">

                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            disabled={pagination.current_page === 1}
                                            onClick={() => handlePageChange(pagination.current_page - 1)}>
                                            Previous
                                        </button>

                                        <button
                                            className={`btn btn-sm ${pagination.current_page === 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handlePageChange(1)}>
                                            1
                                        </button>

                                        {pagination.current_page > 3 && <span className="px-2">...</span>}

                                        {Array.from({ length: 5 }, (_, i) => {
                                            const page = pagination.current_page - 2 + i;
                                            if (page > 1 && page < pagination.last_page) {
                                                return (
                                                    <button
                                                        key={page}
                                                        className={`btn btn-sm ${pagination.current_page === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                                        onClick={() => handlePageChange(page)}>
                                                        {page}
                                                    </button>
                                                );
                                            }
                                            return null;
                                        })}

                                        {pagination.current_page < pagination.last_page - 2 && <span className="px-2">...</span>}

                                        {pagination.last_page > 1 && (
                                            <button
                                                className={`btn btn-sm ${pagination.current_page === pagination.last_page ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => handlePageChange(pagination.last_page)}>
                                                {pagination.last_page}
                                            </button>
                                        )}

                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            disabled={pagination.current_page === pagination.last_page}
                                            onClick={() => handlePageChange(pagination.current_page + 1)}>
                                            Next
                                        </button>

                                    </div>
                                </div>
                            )}

                        </div>

                    </div>
                </div>

                <ToastContainer />
            </Header>

            <Footer />
        </>
    )
}

export default Business;